import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuthentication, useB3Config, useModalStore } from "../../../../global-account/react/index.js";
import { client } from "../../../../shared/utils/thirdweb.js";
import { getSessionDurationDays, SESSION_DURATION_LABELS } from "../../../../shared/utils/session-duration.js";
import { Bell, Clock, Link, Loader2 } from "lucide-react";
import { useState } from "react";
import { useProfiles } from "thirdweb/react";
import SignOutIcon from "../icons/SignOutIcon.js";
import ModalHeader from "../ModalHeader/ModalHeader.js";
import SettingsMenuItem from "./SettingsMenuItem.js";
import SettingsProfileCard from "./SettingsProfileCard.js";
const SettingsContent = t0 => {
  const $ = _c(29);
  const {
    partnerId,
    onLogout,
    chain
  } = t0;
  const {
    authStrategy
  } = useB3Config();
  const isBetterAuth = authStrategy === "better-auth";
  const setB3ModalContentType = useModalStore(_temp);
  const setB3ModalOpen = useModalStore(_temp2);
  const {
    logout,
    user
  } = useAuthentication(partnerId);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const t1 = user?.preferences;
  let t2;
  if ($[0] !== partnerId || $[1] !== t1) {
    t2 = getSessionDurationDays(t1, partnerId);
    $[0] = partnerId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const sessionDays = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      client
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: t4
  } = useProfiles(t3);
  let t5;
  if ($[4] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const profilesRaw = t5;
  let t6;
  if ($[6] !== profilesRaw) {
    t6 = profilesRaw.filter(_temp3);
    $[6] = profilesRaw;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const profiles = t6;
  let t7;
  if ($[8] !== chain || $[9] !== onLogout || $[10] !== partnerId || $[11] !== setB3ModalContentType || $[12] !== setB3ModalOpen) {
    t7 = type => {
      if (type === "home") {
        setB3ModalContentType({
          type: "manageAccount",
          chain,
          partnerId,
          onLogout,
          activeTab: "home"
        });
      } else {
        if (type === "swap") {
          setB3ModalContentType({
            type: "manageAccount",
            chain,
            partnerId,
            onLogout,
            activeTab: "tokens"
          });
        } else {
          if (type === "linkAccount") {
            setB3ModalContentType({
              type: "linkAccount",
              chain,
              partnerId
            });
          } else {
            if (type === "notifications") {
              setB3ModalContentType({
                type: "notifications",
                chain,
                partnerId
              });
            } else {
              if (type === "sessionDuration") {
                setB3ModalContentType({
                  type: "sessionDuration",
                  chain,
                  partnerId
                });
              } else {
                setB3ModalContentType({
                  type: "avatarEditor"
                });
              }
            }
          }
        }
      }
      setB3ModalOpen(true);
    };
    $[8] = chain;
    $[9] = onLogout;
    $[10] = partnerId;
    $[11] = setB3ModalContentType;
    $[12] = setB3ModalOpen;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleNavigate = t7;
  let t8;
  if ($[14] !== logout || $[15] !== onLogout || $[16] !== setB3ModalOpen) {
    t8 = async () => {
      setLogoutLoading(true);
      await logout();
      onLogout?.();
      setB3ModalOpen(false);
      setLogoutLoading(false);
    };
    $[14] = logout;
    $[15] = onLogout;
    $[16] = setB3ModalOpen;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const onLogoutEnhanced = t8;
  let t9;
  if ($[18] !== handleNavigate || $[19] !== isBetterAuth || $[20] !== logoutLoading || $[21] !== onLogoutEnhanced || $[22] !== profiles || $[23] !== sessionDays) {
    let t10;
    if ($[25] !== handleNavigate) {
      t10 = () => handleNavigate("notifications");
      $[25] = handleNavigate;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== handleNavigate) {
      t11 = () => handleNavigate("sessionDuration");
      $[27] = handleNavigate;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    t9 = _jsxs("div", {
      className: "flex h-[470px] flex-col",
      children: [!isBetterAuth && _jsx(ModalHeader, {
        showBackButton: false,
        showCloseButton: false,
        title: "Settings"
      }), _jsx("div", {
        className: "p-5",
        children: _jsx("div", {
          className: "b3-modal-settings-profile-card dark:border-b3-line dark:bg-b3-background flex items-center rounded-xl border border-[#e4e4e7] bg-[#f4f4f5] p-4",
          children: _jsx(SettingsProfileCard, {})
        })
      }), _jsxs("div", {
        className: "space-y-3 px-5",
        children: [!isBetterAuth && _jsx(SettingsMenuItem, {
          icon: _jsx(Link, {
            size: 18,
            className: "text-[#51525c]"
          }),
          title: "Linked Accounts",
          subtitle: `${profiles.length} connected account${profiles.length > 1 ? "s" : ""}`,
          onClick: () => handleNavigate("linkAccount")
        }), _jsx(SettingsMenuItem, {
          icon: _jsx(Bell, {
            size: 18,
            className: "text-[#51525c]"
          }),
          title: "Notifications",
          subtitle: "Manage your notifications",
          onClick: t10
        }), _jsx(SettingsMenuItem, {
          icon: _jsx(Clock, {
            size: 18,
            className: "text-[#51525c]"
          }),
          title: "Stay signed in",
          subtitle: SESSION_DURATION_LABELS[sessionDays] ?? `${sessionDays} days`,
          onClick: t11
        })]
      }), _jsx("div", {
        className: "mt-auto px-5 pb-5",
        children: _jsxs("button", {
          type: "button",
          className: "b3-modal-sign-out-button border-b3-line hover:bg-b3-line bg-b3-background dark:bg-b3-background dark:border-b3-line dark:hover:bg-b3-line/80 flex w-full items-center justify-center gap-1.5 rounded-xl border border-solid p-3 transition-colors",
          onClick: onLogoutEnhanced,
          disabled: logoutLoading,
          style: {
            boxShadow: "inset 0px 0px 0px 1px rgba(10,13,18,0.18), inset 0px -2px 0px 0px rgba(10,13,18,0.05)"
          },
          children: [logoutLoading ? _jsx(Loader2, {
            className: "text-b3-grey animate-spin",
            size: 20
          }) : _jsx(SignOutIcon, {
            size: 20,
            className: "text-b3-grey",
            color: "currentColor"
          }), _jsx("p", {
            className: "text-b3-grey dark:text-b3-foreground-muted font-neue-montreal-semibold text-base",
            children: "Sign out"
          })]
        })
      })]
    });
    $[18] = handleNavigate;
    $[19] = isBetterAuth;
    $[20] = logoutLoading;
    $[21] = onLogoutEnhanced;
    $[22] = profiles;
    $[23] = sessionDays;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default SettingsContent;
function _temp(state) {
  return state.setB3ModalContentType;
}
function _temp2(state_0) {
  return state_0.setB3ModalOpen;
}
function _temp3(profile) {
  return !["custom_auth_endpoint"].includes(profile.type);
}